import { contactsHistory, validateContact, sendEmailsToContacts, redispatchContacts } from '@/services/ContactsValidationService'

const state = {
  history: [],
  historyPagination: {
    page: 1,
    perPage: 10,
    totalPages: 1,
    total: 0,
  },
  validationResult: {
    validCount: 0,
    invalidCount: 0,
    validEmails: [],
  },
}

const mutations = {
  setHistory(state, payload) {
    state.history = Array.isArray(payload) ? payload : []
  },

  setHistoryPagination(state, payload) {
    state.historyPagination = {
      page: Number(payload?.page || 1),
      perPage: Number(payload?.perPage || 10),
      totalPages: Number(payload?.totalPages || 1),
      total: Number(payload?.total || 0),
    }
  },

  setValidationResult(state, payload) {
    state.validationResult = {
      validCount: payload?.validCount || 0,
      invalidCount: payload?.invalidCount || 0,
      validEmails: Array.isArray(payload?.validEmails) ? payload.validEmails : [],
    }
  },

  resetValidationResult(state) {
    state.validationResult = {
      validCount: 0,
      invalidCount: 0,
      validEmails: [],
    }
  },
}

const actions = {
  async getContactsHistory({ commit, dispatch, rootGetters }, payload = {}) {
    try {
      const response = await contactsHistory({
        page: payload?.page || 1,
        perPage: payload?.perPage || 10,
        search: payload?.search || '',
        userId: payload?.userId,
      }, rootGetters.getToken)

      const historyItems = Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response)
          ? response
          : []

      commit('setHistory', historyItems)
      commit('setHistoryPagination', {
        page: response?.current_page || payload?.page || 1,
        perPage: response?.per_page || payload?.perPage || 10,
        totalPages: response?.last_page || 1,
        total: response?.total || historyItems.length,
      })

      return response
    } catch (error) {
      commit('setHistory', [])
      commit('setHistoryPagination', {
        page: payload?.page || 1,
        perPage: payload?.perPage || 10,
        totalPages: 1,
        total: 0,
      })
      dispatch(
        'toastfy/activeErrorNotification',
        { text: error?.response?.data?.message || 'Erro ao buscar histórico de disparos.' },
        { root: true }
      )
      throw error
    }
  },

  resetValidationResult({ commit }) {
    commit('resetValidationResult')
  },

  async validateContactsFile({ commit, dispatch, rootGetters }, payload) {
    try {
      if (!(payload instanceof File || payload instanceof Blob)) {
        throw new Error('Arquivo inválido para validação.')
      }

      const formData = new FormData()
      formData.append('file', payload, payload?.name || 'contacts-upload.csv')

      const response = await validateContact(formData, rootGetters.getToken)

      commit('setValidationResult', {
        validCount: response?.valid_count || 0,
        invalidCount: response?.invalid_count || 0,
        validEmails: response?.valid_emails || [],
      })

      return response
    } catch (error) {
      commit('resetValidationResult')
      dispatch(
        'toastfy/activeErrorNotification',
        { text: error?.response?.data?.message || 'Erro ao validar arquivo de contatos.' },
        { root: true }
      )
      throw error
    }
  },

  async sendEmailsToContacts({ dispatch, rootGetters }, payload) {
    try {
      const formData = new FormData()
      formData.append('subject', payload?.subject || '')
      formData.append('body', payload?.body || '')
      formData.append('smtp_setting_id', String(payload?.smtp_setting_id || ''))

      const emails = Array.isArray(payload?.emails) ? payload.emails : []
      emails.forEach((email) => {
        formData.append('emails[]', email)
      })

      const attachments = Array.isArray(payload?.attachments) ? payload.attachments : []
      attachments.forEach((file) => {
        if (file instanceof File || file instanceof Blob) {
          formData.append('attachments[]', file, file?.name || 'attachment')
        }
      })

      return await sendEmailsToContacts(formData, rootGetters.getToken)
    } catch (error) {
      dispatch(
        'toastfy/activeErrorNotification',
        { text: error?.response?.data?.message || 'Erro ao enviar emails para os contatos.' },
        { root: true }
      )
      throw error
    }
  },

  async redispatchContacts({ dispatch, rootGetters }, payload) {
    try {
      return await redispatchContacts(payload, rootGetters.getToken)
    } catch (error) {
      dispatch(
        'toastfy/activeErrorNotification',
        { text: error?.response?.data?.message || 'Erro ao redisparar contatos.' },
        { root: true }
      )
      throw error
    }
  },
}

const getters = {
  getContactsHistory: (state) => state.history,
  getContactsHistoryPagination: (state) => state.historyPagination,
  getValidationResult: (state) => state.validationResult,
  getValidatedEmails: (state) => state.validationResult.validEmails,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
